const socials = [
  { label: "LinkedIn", d: "M4 4h4v16H4V4zm6 0h3.8v2.2h.05c.53-1 1.83-2.2 3.77-2.2C21.5 4 22 6.3 22 9v11h-4v-9.5c0-2.3-.04-5.2-3.17-5.2-3.17 0-3.66 2.47-3.66 5v9.7h-4V4z" },
  { label: "X", d: "M18 3h3l-7.5 8.6L22 21h-6.4l-5-6.5L4.8 21H2l8.1-9.3L2 3h6.5l4.5 6 5-6z" },
  { label: "Facebook", d: "M13 22v-8h3l.5-4H13V7.5c0-1.1.3-2 2-2H17V2l-3 0c-3 0-5 1.8-5 5v3H6v4h3v8h4z" },
  { label: "Instagram", d: "M7 2h10a5 5 0 015 5v10a5 5 0 01-5 5H7a5 5 0 01-5-5V7a5 5 0 015-5zm5 5a5 5 0 100 10 5 5 0 000-10zm0 2a3 3 0 110 6 3 3 0 010-6zm5.5-3a1 1 0 100 2 1 1 0 000-2z" },
  { label: "YouTube", d: "M23 7.5s-.2-1.6-.9-2.3c-.8-.9-1.8-.9-2.2-1C16.7 4 12 4 12 4s-4.7 0-7.9.2c-.5.1-1.4.1-2.2 1C1.2 5.9 1 7.5 1 7.5S.8 9.4.8 11.3v1.4c0 1.9.2 3.8.2 3.8s.2 1.6.9 2.3c.8.9 1.9.9 2.4 1C6 19.9 12 20 12 20s4.7 0 7.9-.2c.4-.1 1.4-.1 2.2-1 .7-.7.9-2.3.9-2.3s.2-1.9.2-3.8v-1.4c0-1.9-.2-3.8-.2-3.8zM9.7 14.6V8.4l6.3 3.1-6.3 3.1z" },
];

export function SiteFooter() {
  return (
    <footer className="text-navy">
      <div
        style={{
          backgroundImage:
            "linear-gradient(to bottom, #ffffff 0%, var(--sky-bg) 60%, color-mix(in oklab, var(--sky-bg) 70%, white) 100%)",
        }}
      >
        <div className="mx-auto max-w-[1400px] px-5 md:px-10 py-8 flex flex-col md:flex-row items-center justify-between gap-5">
          <div className="flex items-center gap-3">
            {socials.map((s) => (
              <a
                key={s.label}
                href="#"
                aria-label={s.label}
                className="w-10 h-10 inline-flex items-center justify-center rounded-full bg-navy text-white hover:bg-[var(--leaf-deep)] transition shadow-md"
              >
                <svg viewBox="0 0 24 24" className="w-4 h-4" fill="currentColor" aria-hidden>
                  <path d={s.d} />
                </svg>
              </a>
            ))}
          </div>
          <nav className="flex items-center gap-6 text-sm text-navy">
            <a href="/impressum" className="hover:text-orange transition">Impressum</a>
            <a href="/datenschutz" className="hover:text-orange transition">Datenschutzvereinbarung</a>
            <a href="/agb" className="hover:text-orange transition">AGB</a>
          </nav>
        </div>
      </div>
      <div className="bg-navy border-t border-white/10">
        <div className="mx-auto max-w-[1400px] px-5 md:px-10 py-3 text-xs text-white/55 text-center md:text-left">
          © {new Date().getFullYear()} Energie- und Fördermittel Zentrum Deutschland
        </div>
      </div>
    </footer>
  );
}

